
// src/web/components/video-viewer.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import { translate } from 'react-i18next'
import { PropTypes } from 'prop-types'
import context from '../../helpers/context'
import classnames from 'classnames'
import HLS from 'hls.js'
import _ from 'lodash'
import Chip from 'react-toolbox/lib/chip'
import Avatar from 'react-toolbox/lib/avatar'
import videoViewerTheme from './themes/video-viewer.css'
import Tooltip from 'react-toolbox/lib/tooltip'

const TooltipAvatar = Tooltip(Avatar)

class VideoViewer extends React.Component {
  state = { played: false }

  componentDidMount() {
    if (this.refs.video) {
      const hls = new HLS()
      hls.loadSource(this.props.video.file.url)
      hls.attachMedia(ReactDOM.findDOMNode(this.refs.video))

      ReactDOM.findDOMNode(this.refs.video).addEventListener('play', this.videoPlay)
      ReactDOM.findDOMNode(this.refs.video).addEventListener('pause', this.videoPause)
      ReactDOM.findDOMNode(this.refs.video).addEventListener('ended', this.videoEnd)
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (this.props.video != nextProps.video) {
      if (this.refs.video) {
        const hls = new HLS()
        hls.loadSource(nextProps.video.file.url)
        hls.attachMedia(ReactDOM.findDOMNode(this.refs.video))
      }
    }
  }

  componentWillUnmount() {
    ReactDOM.findDOMNode(this.refs.video).removeEventListener('play', this.videoPlay)
    ReactDOM.findDOMNode(this.refs.video).removeEventListener('pause', this.videoPause)
    ReactDOM.findDOMNode(this.refs.video).removeEventListener('ended', this.videoEnd)
  }

  videoPlay = ()=> this.setState({ played: true })
  videoPause = ()=> this.setState({ played: false })
  videoEnd = ()=> this.props.parent_component == 'CHAT_MESSAGE' && this.props.onEnd()

  onPlay = (ev)=> {
    if (!this.state.played) {
      ev.preventDefault(); ev.target.play()
    }
    else {
      ev.preventDefault(); ev.target.pause()
    }
  }

  showImagesView = (video)=> {
    this.props.showImagesView('GROUP_TIMELINE', this.props.params.diary_id, video)
  }

  render() {
    const userAgent = window.navigator.userAgent.toLowerCase()
    const {
      t,
      video,
      parent_component,
      params,
      onEnd,
      showImagesView,
    } = this.props

    if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1)
      return (
        <div style={{ padding: '10px', fontSize: '80%' }}>
        お使いのWebブラウザはビデオ再生に対応していません。
        Google ChromeやFirefoxブラウザなどのご利用をお勧めします。</div>)

    return (
      <div className={videoViewerTheme.baseDiv}
          style={{ padding: parent_component == 'CHAT_MESSAGE' ? '0px' : undefined }} >
        {parent_component == 'ATTACHMENTS_PAGE' && !params.isAudio &&
          <div className={videoViewerTheme.iconDiv} >
            <span style={{ width: '80%', marginTop: '10px', overflow: 'hidden',textOverflow: 'ellipsis',whiteSpace: 'nowrap'}}>{video.name}</span>
            <Avatar className={videoViewerTheme.avatar}
              icon='fullscreen'
              onClick={()=> this.showImagesView(video)} />
            <a key={video.video_id} style={{float: 'right'}}
                  href={video.file.orig_url} >
              <Avatar className={videoViewerTheme.avatar}
                icon='file_download' />
            </a>
          </div>
        }
        {parent_component == 'TIMELINE_PAGE' && video.content_type.match(/^video/) &&
          <div className={videoViewerTheme.iconDiv} >
            <a key={video.video_id} style={{float: 'right'}} href={video.file.orig_url} >
              <TooltipAvatar className={videoViewerTheme.tooltipAvatar} icon='file_download' tooltip={t('label:ダウンロード')}/>
            </a>
          </div>
        }
        {parent_component == 'TIMELINE_PAGE' && video.content_type.match(/^audio/) &&
          <div className={videoViewerTheme.audioArea}>
            <Chip className={videoViewerTheme.audioChip}>
              <Avatar icon={'audiotrack'} className={video.status && video.status != 'committed' ? undefined : classnames(videoViewerTheme.avatar, 'audiotrack')}  />
              <span>{video.name}</span>
            </Chip> 
          </div>}
        {parent_component != 'CHAT_MESSAGE' && 
          <video className={video.content_type.match(/^video/) ?  
            parent_component == 'TIMELINE_PAGE' ? videoViewerTheme.video : videoViewerTheme.dialogVideo  :  parent_component == 'TIMELINE_PAGE' ?  videoViewerTheme.audio : videoViewerTheme.dialogAudio}
            onClick={(ev)=> this.onPlay(ev)}
            controls ref="video"/>}
        {parent_component == 'CHAT_MESSAGE'&&
          <audio
              onClick={(ev)=> this.onPlay(ev)}
              controls ref="video"/>
        }
      </div>
    )
  }
}

export default translate()(context({ showImagesView: PropTypes.func })(VideoViewer))



// WEBPACK FOOTER //
// ./src/web/components/video-viewer.jsx